import Service from "../services/service";

export default class DocumentProvider extends Service {
  update({document, collectionKey}) {
    return this.persist({json: {document: document}, collectionKey: collectionKey});
  }

  move({document, newParentIdTree, collectionKey}) {
    return this.persist({
      endpoint: `move`,
      json: {new_parent_id_tree: newParentIdTree},
      document: document,
      collectionKey: collectionKey
    });
  }

  archive({document, collectionKey}) {
    return this.persist({endpoint: `archive`, document: document, collectionKey: collectionKey});
  }

  persist({endpoint = '', json, method = 'put', document = json.document, collectionKey = null}: any) {
    return new Promise((resolve, reject) => {
      const data = {
        _method: method,
        authenticity_token: this.csrfToken()
      };

      if (json) {
        window.AppConfig.mergeJson(data, json);
      }

      $.ajax({
        url: `/${collectionKey || document.collectionKey}/${document.id}/documents/${endpoint}`,
        type: 'POST',
        dataType: 'json',
        data: data,
      }).done(function (result) {
        resolve(result);
      }).fail(function (result) {
        reject();
      });
    });
  }
}
